// Free monthly chapter content (rotates monthly).
// Update this file when CURRENT_GIFT_CHAPTER changes in backend/server.py.

export const CURRENT_GIFT_CHAPTER = {
  month: 'April 2026',
  chapterNumber: 1,
  title: "The Moment You Ask \u201CNow What?\u201D",
  subtitle: "Chapter 1 from F.U.C.K. T.H.A.T.T. \u2014 What Do I Want NOW!",
  amazonUrl: 'https://www.amazon.com/dp/B0GZN2ZZ5V',
  bookCover:
    'https://customer-assets.emergentagent.com/job_5d4ad1e7-aed7-4c2c-bd02-652824eb659e/artifacts/m0moy2po_FUCK_THATT_What_Do_I_Want_NOW_KDP_Ebook_Cover_1600x2560.png',
  // Each block is a structured part of the chapter for beautiful rendering.
  content: [
    {
      type: 'paragraph',
      text: 'The question usually does not come when everything is falling apart.',
    },
    {
      type: 'paragraph',
      text: 'Sometimes it comes when things look good on the outside.\nYou have survived. You have achieved. You have checked boxes. You may even have what you once prayed for.',
    },
    { type: 'emphasis', text: 'But something still feels unfinished.' },
    {
      type: 'paragraph',
      text: 'That feeling does not mean you are ungrateful. It means you are being called.',
    },
    {
      type: 'paragraph',
      text: 'A lot of people confuse gratitude with settling. They think if they say they want more, they are dishonoring what they already have. But wanting more life, more peace, more purpose, more joy, more money, more love, more freedom, or more truth does not make you ungrateful.',
    },
    { type: 'revelation', text: 'It makes you awake.' },
    {
      type: 'paragraph',
      text: 'The \u201CNow what?\u201D season is sacred because it means the old version of you has completed her assignment.',
    },
    {
      type: 'emphasis',
      text: 'She got you here. Now she cannot take you there.',
    },
    {
      type: 'paragraph',
      text: 'That is why this moment feels confusing. You are not who you used to be, but you may not fully know who you are becoming.',
    },
    { type: 'paragraph', text: 'And that is okay.' },
    {
      type: 'paragraph',
      text: 'This is where you stop asking everybody else what your life should look like.\nThis is where you get quiet enough to hear the God in you.\nThis is where you begin again \u2014 not from failure, but from wisdom.',
    },
    { type: 'subheading', text: 'SOUL WORK' },
    { type: 'paragraph', text: 'Take out your journal and answer honestly:' },
    {
      type: 'list',
      items: [
        'Where in my life am I asking, \u201CNow what?\u201D',
        'What am I tired of pretending I still want?',
        'What part of me is ready to be seen, heard, or expressed?',
        'What old version of me deserves gratitude before I release her?',
      ],
    },
    { type: 'subheading', text: 'REAL TALK REFLECTION' },
    { type: 'paragraph', text: 'You are not lost.\nYou are between identities.' },
    {
      type: 'paragraph',
      text: 'The woman you were got you here. The woman you are becoming needs you to stop dragging the old script into the new season.',
    },
    { type: 'revelation', text: 'I AM allowed to want something new.' },
  ],
};
